import React from 'react';
import { makeStyles, Theme, createStyles, Typography } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import {removeCapitalization} from '../../../../utils';

type Props = { children?: string, loading?: boolean };
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.common.black,
      textAlign: 'left',
      width: '100%',
      display: 'block',
      fontWeight: 'bold',
      fontSize: '24px',
      lineHeight: '29px'
    }
  }));

export function ReportTitle(props: Props) {
  const classes = useStyles(props);
  const { children, loading } = props;

  if (loading) {
    return <Skeleton variant="rect" width={780} height={29} className={classes.root} />
  }

  const title = children ? removeCapitalization(children) : children;
  return (
    <Typography className={classes.root} variant="h1" >
      {title}
    </Typography>
  );
}
